import { render, staticRenderFns } from "./binary-user.vue?vue&type=template&id=922bfaa8&scoped=true"
import script from "./binary-user.vue?vue&type=script&lang=js"
export * from "./binary-user.vue?vue&type=script&lang=js"
import style0 from "./binary-user.vue?vue&type=style&index=0&id=922bfaa8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "922bfaa8",
  null
  
)

export default component.exports